import {
    convertCurrencyFormat,
    RaikoBaseCardContainer,
    RaikoBaseContainer, RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoTableTitleContainer, showErrorMessage, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {OtherPaymentsService} from "../otherPayments/OtherPaymentsService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useAuthState} from "../../context/AuthContext";
import {useParams} from "react-router-dom";
import {preparationRowsUsersTable} from "../../pages/users/Users";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function PurchaseHistory() {
    const [numberOfItems, setNumberOfItems] = useState("");
    const [PurchaseHistoryList, setPurchaseHistoryList] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [page, setPage] = useState(0);
    const size = 20;

    const {fundID} = useAuthState()
    const {id: paymentId} = useParams()

    useEffect(() => {
        getBuyRequestsListFromServer()
    }, [fundID, paymentId])

    const loading = new LoadingHelper(useLoadingDispatcher());

    const service = new OtherPaymentsService()


    function preparationTableRows(id, number, fullName, nationalCode, phoneNumber, amount, price, doAt) {
        return {
            id: id,
            number: number,
            fullName: fullName,
            nationalCode: nationalCode,
            phoneNumber: phoneNumber,
            amount: amount,
            price,
            doAt: doAt,
        }
    }

    function getBuyRequestsListFromServer() {
        loading.show()
        service.getBuyRequestsList(fundID, paymentId, page, size).then(
            response => {
                setNumberOfItems(response.numberOfItems)
                setPageCount(response.totalPage)
                setPurchaseHistoryList([])
                response.data.map((item, index) => {
                    setPurchaseHistoryList(prevState => [
                        ...prevState,
                        preparationTableRows(
                            item.id,
                            (page * size) + index + 1,
                            item.firstName && item.lastName ? `${item.firstName} ${item.lastName}` : "-",
                            item.nationalCode,
                            item.phoneNumber ? item.phoneNumber : "-",
                            item.amount ? convertCurrencyFormat(item.amount) : "صفر",
                            item.amount,
                            item.doAt
                        )
                    ])
                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <RaikoTableTitleContainer
                    title={"سابقه خرید"}
                    amount={numberOfItems}
                />
                <RaikoCustomTable
                    header={PurchaseHistoryColumns}
                    data={PurchaseHistoryList}
                    isLoading={tableLoading}
                    pageCount={pageCount}
                />
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}
const PurchaseHistoryColumns = [
    {
        id: 'number',
        label: '#'
    },
    {
        id: 'fullName',
        label: 'نام'
    },
    {
        id: 'nationalCode',
        label: 'کد ملی'
    },
    {
        id: 'phoneNumber',
        label: 'شماره همراه'
    },
    {
        id: 'amount',
        label: 'تعداد'
    },
    {
        id: 'price',
        label: 'قیمت کل (ریال)'
    },
    {
        id: 'doAt',
        label: 'تاریخ پرداخت'
    },
];